// @ts-nocheck
const CustomerTranslatorsSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default CustomerTranslatorsSkeleton